export default "__VITE_ASSET__C8oXMd2U__";